import { render, staticRenderFns } from "./PageBoxsTable.vue?vue&type=template&id=6dcfd4a7&"
import script from "./PageBoxsTable.vue?vue&type=script&lang=js&"
export * from "./PageBoxsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports